export default {
  path: 'partners',
  name: 'Partners',
  component: () => import(/* webpackChunkName: "people" */ '../views/PartnersView.vue')
}
